import React from 'react';
import { Mask } from '@smarterservices/smarter-ui';
import Loader from '@ui/context/session/components/Common/Loader';

/**
 * Component to display a loading indicator when seeking to a new position in the video
 */
const SeekingLoader = () => {
  return (
    <Mask
      placement="center"
      themeOverride={{
        borderRadius: '0rem',
        background: 'rgba(255, 255, 255, 0.9)',
        zIndex: 7000,
      }}
    >
      <Loader spinnerSize="small"
        color="primary"
        textSize="medium"
        text='Loading video...' />
    </Mask>
  );
};

export default SeekingLoader;
